import { render, staticRenderFns } from "./ScaniaNextGenInstantaneousDataMenu.vue?vue&type=template&id=fc8356f8&"
import script from "./ScaniaNextGenInstantaneousDataMenu.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenInstantaneousDataMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports